import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/app/src/app/contact/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/src/components/Navbar.tsx");
